import { useCallback } from 'react';

import { createAndFireEvent, useAnalyticsEvents } from '@atlaskit/analytics-next';

import { GROWTH_ANALYTICS_CHANNEL } from './constants';
import type { AnalyticsPayload } from './types';

const createAndFireEventOnGrowth = createAndFireEvent(GROWTH_ANALYTICS_CHANNEL);

export const useAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireAnalyticsEvent = useCallback(
		(payload: AnalyticsPayload) => {
			const fire = createAndFireEventOnGrowth(payload);
			fire(createAnalyticsEvent);
		},
		[createAnalyticsEvent],
	);

	return fireAnalyticsEvent;
};
